export const ANALYSIS_ITEM_META = {
    "sentry-occurrence": {code: "OC", name: "Ocorrências", color: "#c0392b", module: "sentry", img: "sentry.occurrence.svg"},
    "dispatch-attendance": {code: "AT", name: "Atendimentos", color: "#1f5fb0", module: "dispatch", icon: "sw icon-sw-attendance"},
    "dispatch-bogcm": {code: "BO", name: "BO GCM", color: "#0f7a5a", module: "dispatch", img: "sw.bogcm.svg"},
    "dispatch-dispatches": {code: "DP", name: "Despachos", color: "#8a5cc4", module: "dispatch", img: "sw.dispatch.svg"},
    "sos": {code: "SOS", name: "SOS Cidadão", color: "#e08a00", img: "sw.sos.svg"},
    "encounter": {code: "AB", name: "Abordagem", color: "#2b7f8f", img: "sw.approach.svg"},
    "point-items": {code: "PT", name: "Ponto", color: "#5b7083"},
    "waze": {code: "WZ", name: "Waze", color: "#00b3e6"},
};

export const REASON_ITEMS = ["sentry-occurrence", "dispatch-attendance", "dispatch-bogcm", "dispatch-dispatches"];

export const itemUsesReasons = (key) => REASON_ITEMS.includes(key);

export const getMissingReasonKeys = (target = [], items = {}) => target.filter(
    (key) => itemUsesReasons(key) && !(items[key]?.reasons ?? []).length
);

export const getSelectedAnalysisKeys = (items = [], target = []) =>
    items.filter(item => target.includes(item.key)).map(item => item.key);

export const getFilterOptionValue = (option) => {
    if (option === null || option === undefined) return "";
    if (typeof option === "object") return option.value ?? option.id ?? "";
    return option;
};

export const getFilterOptionValues = (options = []) => options
    .map(getFilterOptionValue)
    .filter(value => value !== "");

export const getAnalysisItems = (hasDispatch, boName) => {
    const items = [{key: "sentry-occurrence", ...ANALYSIS_ITEM_META["sentry-occurrence"]}];

    if (hasDispatch) {
        items.push(
            {key: "dispatch-attendance", ...ANALYSIS_ITEM_META["dispatch-attendance"]},
            {key: "dispatch-bogcm", ...ANALYSIS_ITEM_META["dispatch-bogcm"], name: boName || ANALYSIS_ITEM_META["dispatch-bogcm"].name},
            {key: "dispatch-dispatches", ...ANALYSIS_ITEM_META["dispatch-dispatches"]},
            {key: "sos", ...ANALYSIS_ITEM_META["sos"]},
            {key: "encounter", ...ANALYSIS_ITEM_META["encounter"]},
        );
    }

    return items;
};

export const getItemMeta = (key) => ANALYSIS_ITEM_META[key] ?? {code: "?", name: "", color: "#6b7a92"};